(function () {
  'use strict';

  if (window.__productItemPillsBound) return;
  window.__productItemPillsBound = true;

  function updatePrice(card, pill) {
    var price = pill.dataset.price || '';
    var compare = pill.dataset.compare || '';
    var discount = pill.dataset.discount || '';
    var unit = pill.dataset.unit || '';

    var priceEl = card.querySelector('.product_price_current');
    var compareEl = card.querySelector('.product_price_compare');
    var badgeEl = card.querySelector('.product_price_badge');
    var unitEl = card.querySelector('.product_price_unit');
    var priceRow = card.querySelector('.product_price_row');

    if (priceEl) priceEl.textContent = price;

    if (unitEl) {
      if (unit) {
        unitEl.textContent = unit;
        unitEl.hidden = false;
      } else {
        unitEl.hidden = true;
      }
    }

    if (compare) {
      if (!compareEl && priceRow) {
        compareEl = document.createElement('span');
        compareEl.className = 'product_price_compare';
        if (priceEl && priceEl.nextSibling) {
          priceRow.insertBefore(compareEl, priceEl.nextSibling);
        } else {
          priceRow.appendChild(compareEl);
        }
      }
      if (compareEl) {
        compareEl.textContent = compare;
        compareEl.hidden = false;
        compareEl.style.display = '';
      }
    } else if (compareEl) {
      compareEl.hidden = true;
      compareEl.style.display = 'none';
    }

    if (discount) {
      if (!badgeEl && priceRow) {
        badgeEl = document.createElement('span');
        badgeEl.className = 'product_price_badge';
        priceRow.appendChild(badgeEl);
      }
      if (badgeEl) {
        badgeEl.textContent = 'Save ' + discount + '%';
        badgeEl.hidden = false;
        badgeEl.style.display = '';
      }
    } else if (badgeEl) {
      badgeEl.hidden = true;
      badgeEl.style.display = 'none';
    }


    var idInput = card.querySelector('input[name="id"]');
    if (idInput && pill.dataset.variantId) {
      idInput.value = pill.dataset.variantId;
    }

    var soldOut = pill.dataset.available === 'false';
    var addBtn = card.querySelector('[data-makers-add]');
    if (addBtn) {
      addBtn.disabled = soldOut;
      if (soldOut && addBtn.dataset.soldLabel) {
        addBtn.textContent = addBtn.dataset.soldLabel;
      } else if (pill.dataset.addLabel) {
        addBtn.textContent = pill.dataset.addLabel;
      }
    }

    setCardAvailability(card, pill, soldOut);

    var title = card.querySelector('a.product_item_title');
    if (title && pill.dataset.title) {
      title.textContent = pill.dataset.title;
      title.setAttribute('title', pill.dataset.title);
    }

    var img = card.querySelector('.product_item_image img');
    if (img && pill.dataset.image) {
      img.src = pill.dataset.image;
      if (pill.dataset.title) img.alt = pill.dataset.title;
    }
  }

  function setCardAvailability(card, pill, soldOut) {
    card.classList.toggle('product_item--sold-out', soldOut);

    var nextUrl = !soldOut && pill.dataset.url ? pill.dataset.url : '';
    card.querySelectorAll('.product_item_image a, a.product_item_title, [data-product-cta]').forEach(function (link) {
      if (soldOut) {
        if (link.hasAttribute('href')) link.dataset.href = link.getAttribute('href');
        link.removeAttribute('href');
        link.setAttribute('aria-disabled', 'true');
        link.tabIndex = -1;
        return;
      }

      var href = nextUrl || link.getAttribute('href') || link.dataset.href || '';
      if (href) link.setAttribute('href', href);
      link.removeAttribute('aria-disabled');
      link.removeAttribute('tabindex');
    });

    var cta = card.querySelector('[data-product-cta]');
    if (cta) {
      var label = soldOut ? cta.dataset.soldLabel : cta.dataset.shopLabel;
      var span = cta.querySelector('span');
      if (span && label) span.textContent = label;
    }
  }

  function pillUnavailable(pill) {
    return pill.disabled || pill.classList.contains('is-unavailable') || pill.getAttribute('aria-disabled') === 'true' || pill.dataset.available === 'false';
  }

  function activatePill(pill) {
    var variantsEl = pill.closest('.product_item_variants');
    if (!variantsEl) return;

    var card = pill.closest('.product_item');
    if (!card) return;

    if (pill.classList.contains('active')) {
      // Still refresh price in case DOM drifted, but skip class churn
      updatePrice(card, pill);
      return;
    }

    variantsEl.querySelectorAll('.product_variant_pill').forEach(function (p) {
      p.classList.toggle('active', p === pill);
    });

    updatePrice(card, pill);
  }

  function handlePillEvent(e) {
    var pill = e.target && e.target.closest ? e.target.closest('.product_variant_pill') : null;
    if (!pill || pillUnavailable(pill)) return;

    // Keep Swiper from hijacking the gesture
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === 'function') {
      e.stopImmediatePropagation();
    }

    if (e.type === 'click') {
      e.preventDefault();
    }

    activatePill(pill);
  }

  document.addEventListener('click', function (e) {
    var card = e.target.closest('.product_item--sold-out');
    if (!card) return;
    if (e.target.closest('.product_variant_pill') && !pillUnavailable(e.target.closest('.product_variant_pill'))) return;

    var link = e.target.closest('a, button');
    if (link && card.contains(link)) {
      e.preventDefault();
    }
  }, true);

  // Activate as soon as the finger/cursor presses — more reliable than waiting for click
  document.addEventListener('pointerdown', handlePillEvent, true);
  document.addEventListener('click', handlePillEvent, true);
})();
